<template>
    <div class="col-12 col-md-12 col-lg-12 content mb-20 mb-lg-0 ">
      <h1 class="text-center">
        404 Page not found
      </h1>
    </div>
</template>

<script>
    export default {
        name: 'PageNotFound',
        metaInfo() {
            let title = "Clever Staff";
            let description = "The page you are looking for could not be found. Please check the URL and try again.";
            return {
                title: title,
                meta: this.$getMetaTags(title, description)
            }
        },
    }
</script>
